/* Extracted from legacy/index.html inline <script> block.
   Role-aware default landings and chrome profiles. */

export type Role = "programme" | "district" | "school" | "teacher";

export interface RouteTarget {
  level: "home" | "district" | "school" | "class" | "student";
  districtId?: string;
  schoolId?: string;
  classId?: string;
  studentId?: string;
}

export const ROLE_HOMES: Record<Role, RouteTarget> = {
  programme: { level: "home" },
  district:  { level: "district", districtId: "westmore" },
  school:    { level: "school",   districtId: "westmore", schoolId: "eastvale" },
  teacher:   { level: "class",    districtId: "westmore", schoolId: "eastvale", classId: "1C" },
};

export interface RoleProfile {
  name: string;
  title: string;
  contextLabel: string;
}

export const ROLE_PROFILES: Record<Role, RoleProfile> = {
  programme: { name: "Dr Priya Anand",  title: "Programme owner",  contextLabel: "ENSSA Portal" },
  district:  { name: "Dr Samira Ng",    title: "District lead",    contextLabel: "Westmore Region" },
  school:    { name: "Anita Krishnan",  title: "School leader",    contextLabel: "Eastvale Primary" },
  teacher:   { name: "Ms Wilson",       title: "Year 1 teacher",   contextLabel: "Class 1C" },
};
